import ApiClientAsync from "../api/ApiClientAsync";
import { useEffect, useState } from "react";

export default function useStripeSubscriptionManagementLink(locale, authToken, returnUrl) {
  const [subscriptionLink, setSubscriptionLink] = useState(null);
  const apiClient = new ApiClientAsync(locale, authToken);

  useEffect(() => {
    async function fetchSubscriptionLink() {
      try {
        const data = await apiClient.post({
          urlPath: "app.stripe.createCustomerPortalSession",
          data: {
            return_url: returnUrl
          }
        });

        setSubscriptionLink(data.return_url);
      } catch (e) {}
    }

    void fetchSubscriptionLink();
  }, []);

  return subscriptionLink;
}
